import { useBrandIdentity } from 'hooks/useBrandIdentity';
import React from 'react';

type BrandVisualProps = {
    className?: string;
    imageClassName?: string;
    src?: string;
};

/** Side-panel decorative brand image (PayIn, profile, cards, statements, etc.). */
export const BrandVisual: React.FC<BrandVisualProps> = ({
    className,
    imageClassName = 'FillerImage',
    src,
}) => {
    const { fillerImage } = useBrandIdentity();

    return (
        <div className={className ? `BrandVisual ${className}` : 'BrandVisual'} aria-hidden>
            <img
                src={src ?? fillerImage}
                alt=""
                className={imageClassName}
                loading="lazy"
                decoding="async"
            />
        </div>
    );
};
